<template>
    <div class="welcome">
      <v-layout column>
            <v-flex xs12>
                <v-img
                    dark
                    height="250"
                    src="img/cover_photo.png"
                    >
                    <div align="center" class="font-weight-black mt-16 hidden-sm-and-down">
                        <h1>The Women in Tech Accelerator Kenya - Cohort 9</h1>
                    </div>
                    <div align="center" class="font-weight-black title mt-3 hidden-md-and-up">
                        The Women in Tech Accelerator Kenya - Cohort 9
                    </div>
                    <div align="center" class="mt-2">
                        #StanChartFoundation / #InspireImpact / #WomenInTech
                    </div>
                    <div align="center" class="mt-2">
                        <v-btn depressed class="secondary mt-5" v-if="!isAuthenticated" @click="changeLoginCardState">
                            Apply Now! <v-icon right>mdi-file-document-plus</v-icon>
                        </v-btn>
                        <v-btn depressed class="secondary mt-5" router to="/cohort-9/apply-now" v-if="isAuthenticated">
                            Apply Now! <v-icon right>mdi-file-document-plus</v-icon>
                        </v-btn>
                    </div>
                </v-img>
            </v-flex>
            <v-flex xs12 class="white">
                <v-container>
                    <div align="left" class="mt-15">
                        <div class="headline font-weight-black">
                            What is the Women in Tech Accelerator Kenya?
                        </div>
                        <p class="grey--text text--darken-1">
                            The Women in Tech Accelerator Kenya is an initiative that has been funded by the Standard Chartered Foundation and implemented by Village Capital and @iBizAfrica Incubation Centre at Strathmore University. The programme supports ambitious women entrepreneurs with the tools, networks, and mentorship needed to strengthen their businesses and unlock sustainable growth. Through structured business training, expert mentorship, and access to catalytic grant funding, the Women in Tech Accelerator equips founders to build resilient startups, create jobs, and drive innovation across Kenya’s entrepreneurial ecosystem.
                        </p>
                        <div class="headline font-weight-black">
                            Who are we looking for?
                        </div>
                        <p class="grey--text text--darken-1">
                            We are seeking to recruit the best entrepreneurial minds, women-led startups as key drivers of innovation in business.
                        </p>
                        <p class="grey--text text--darken-1">
                            The principle founder must be:
                            <ol class="grey--text text--darken-1">
                                <li>A woman.</li>
                                <li>Between 18 to 35 years of age.</li>
                                <li>Of <b>Kenyan</b> nationality or permanent residency.</li>
                            </ol>
                        </p>
                        
                        <div class="headline font-weight-black mt-5">
                            Eligibility criteria
                        </div>
                        <ol class="grey--text text--darken-1">                            
                            <li>
                                Women-led founders between 18-35 years old.
                            </li>
                            <li>
                                Business must be headquartered and operating in Kenya.
                            </li>
                            <li>
                                Legally registered, for-profit startup (1–10 employees).
                            </li>
                            <li>
                                Must have a Tax Compliance Certificate
                            </li>
                            <li>
                                Revenue-generating, with an annual revenue between KES 500,000 – 1,000,000.
                            </li>
                            <li>
                                At least one woman founder and one full-time founder must be based in Nairobi, Kenya.
                            </li>
                            <li>
                                Business must be tech-based or tech-enabled.
                            </li>
                            <li>
                                Business models must have a clear focus on inclusivity and address specific social, economic, or environmental issues aligned with the Sustainable Development Goals (SDGs) in any sector.
                            </li>
                            <li>
                                Persons with Disabilities (PWDs) are encouraged to apply.
                            </li>                                
                        </ol>
                        <div class="headline font-weight-black mt-5">
                            Program benefits
                        </div>
                        <ol class="grey--text text--darken-1">
                            <li>12 weeks of an immersive learning experience</li>
                            <li>Access to a leading network of coaching experts</li>
                            <li>Access to B2B networking opportunities</li>
                            <li>Personalized mentorship sessions to address your unique business needs</li>
                            <li>Opportunity to join a supportive Women in Tech Alumni Network</li>
                            <li>$10,000 equity-free grant seed funding for the top 7 finalists</li>
                            <li>6 months ongoing support from Village Capital and @iBizAfrica to assist with go-to-market and scale for the top 7 finalists.</li>
                        </ol>
                        <div align="center" class="mt-2">
                            <v-btn depressed class="secondary mt-5" v-if="!isAuthenticated" @click="changeLoginCardState">
                                Apply Now! <v-icon right>mdi-file-document-plus</v-icon>
                            </v-btn>
                            <v-btn depressed class="secondary mt-5" router to="/cohort-9/apply-now" v-if="isAuthenticated">
                                Apply Now! <v-icon right>mdi-file-document-plus</v-icon>
                            </v-btn>
                        </div>
                        <div align="center" class="hidden-sm-and-down mt-7">
                            <video poster="vid/how-to-apply.png" src="vid/how-to-apply.mp4" controls height="400"></video>
                        </div>
                        <div align="center" class="hidden-md-and-up mt-7">
                            <video poster="vid/how-to-apply.png" src="vid/how-to-apply.mp4" controls height="170"></video>
                        </div>

                        <div class="my-10 mx-5">
                            <v-divider></v-divider>
                        </div>
                        <div class="headline font-weight-black mt-5">
                            Terms and conditions
                        </div>
                        <p class="grey--text text--darken-1 mb-15">
                            Successful completion of the Women in Tech Incubation Program is compulsory, whether in-person or virtual sessions.
                        </p>
                    </div>
                </v-container>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
import apiCall from "@/utils/api";
import { mapState, mapGetters, mapActions } from "vuex";
import Vue from "vue";

export default {
  components: {
    
  },
  data() {
    return {
      path: process.env.VUE_APP_API_URL,
      color: "",
      message: "",
      snackbar: false,
      drawer: false,

      absolute: true,
      overlay: true,
      opacity: 0.3,
    };
  },
  mounted() {
    
  },
  created() {
    window.scrollTo(0, 0);
   
  },
  methods: {
    ...mapActions([
        "changeLoginCardState"
    ]),
      
  },
  computed: {
    ...mapGetters([
        "darkState",
        "isAuthenticated"
    ]),
  },
};
</script>
